import { BaseButton } from "components/buttons/BaseButton";
import { useEffect } from "react";
import { UseFormSetValue, FieldPath } from "react-hook-form";
import { useKeyPress } from "hooks/useKeyPress";
import SelectDate from "components/UI/SelectDate";
import { ISignUpFieldValues } from "../AuthSignUp";
import authPopupClasses from "./../AuthPopup.module.scss";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
}

const SignUpBirthStep = (props: IProps) => {
  const { next, setValue } = props;

  const handleBirth = (value: number) => {
    setValue<FieldPath<ISignUpFieldValues>>("birthday", value);
  };
  const enterPressed = useKeyPress("Enter");

  useEffect(() => {
    if (enterPressed) {
      next();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <div>
      <SelectDate onChange={handleBirth}/>

      <div className={authPopupClasses.Footer}>
        <BaseButton type="button" onClick={next}>Next</BaseButton>
      </div>
    </div>
  );
};

export default SignUpBirthStep;
